import { render, staticRenderFns } from "./perseo_almacen_listado.vue?vue&type=template&id=0aefc5d6&scoped=true"
import script from "./perseo_almacen_listado.vue?vue&type=script&lang=js"
export * from "./perseo_almacen_listado.vue?vue&type=script&lang=js"
import style0 from "./perseo_almacen_listado.vue?vue&type=style&index=0&id=0aefc5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aefc5d6",
  null
  
)

export default component.exports